import { ExperimentKeys } from '../../experiments/ExperimentKeys';
import { getHistory } from '../../routing/history';
import { reenrollExperiment } from '../experiments/action-creators';
import { PurchaseActionTypes } from './action-types';
import { getIsMonthlySingleProduct } from './selectors';
export const setProductInfo = productInfo => dispatch => {
  return dispatch({
    type: PurchaseActionTypes.SetProductInfo,
    productInfo
  });
};
export const setHasSeatsChanged = (hasSeatsChanged = true) => dispatch => {
  dispatch({
    type: PurchaseActionTypes.SetHasSeatsChanged,
    hasSeatsChanged
  });
};
export const setAdditionalSeats = (additionalSeats, hasSeatsChanged = true) => dispatch => {
  dispatch({
    type: PurchaseActionTypes.SetAdditionalSeats,
    additionalSeats,
    hasSeatsChanged
  });
  dispatch(setHasSeatsChanged(hasSeatsChanged));
};
export const checkDtbIdIsUpToDate = () => (dispatch, getState) => {
  const state = getState();
  if (state.purchase.hasSeatsChanged) {
    dispatch({
      type: PurchaseActionTypes.UpdateDtbId
    });
  } else {
    dispatch({
      type: PurchaseActionTypes.DtbIdIsUpToDate
    });
  }
};
export const updateDtbIdInUrl = dtbId => dispatch => {
  const searchParams = new URLSearchParams(getHistory().location.search);
  searchParams.set('dtbId', dtbId);
  getHistory().replace(`${getHistory().location.pathname}?${searchParams}`);
  dispatch({
    type: PurchaseActionTypes.DtbIdIsUpToDate
  });
};
export const checkAcq151CanBeReenrolled = () => (dispatch, getState) => {
  const state = getState();
  if (state.purchase && getIsMonthlySingleProduct(state)) {
    dispatch(reenrollExperiment(ExperimentKeys.ACQ0151));
  }
};